import client from "api/client";


const _client = client.route("/partner");

const partner = {
	create: (payload) => _client.post("/create", payload),
	featured: () => _client.get("/featured"),
	getByProfile: (profileId) => _client.get(`/status/${profileId}`)
};

export default partner;